/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MoveToDetailsIconContainer from '../../NDC/component/MoveToDetailsIconContainer/MoveToDetailsIconContainer';
import SearchComponent from '../../NDC/component/NDCByDrugName/SearchComponent';
import TableComponent from '../../NDC/component/NDCByDrugName/TableComponent';
import {
  checkURAAndAddToDetailsTable,
  dispatchErrorMessages,
  removeFromURADetailsTableData,
  setURADetailsTableData,
  setURASearchByDrugNameTableData,
  setURASearchLoading,
} from '../store/actions';
import URADetailsTable from './URADetailsTable';

const SearchByDrugName = ({
  fullScreen,
  setFullScreen,
  setError,
  validateForm,
  setClickedViewButton,
}) => {
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [leftTableFullScreen, setLeftTableFullScreen] = useState(fullScreen);
  const [rightTableFullScreen, setRightTableFullScreen] = useState(fullScreen);

  const searchByDrugNameTableData = useSelector(
    (state) => state.sharedState.URASearchReducer.searchByDrugNameTableData
  );

  const handleLeftTableFullScreenView = (fullScreenView = false) => {
    setLeftTableFullScreen(fullScreenView);
    if (fullScreenView) setRightTableFullScreen(false);
    if (fullScreenView || rightTableFullScreen) {
      setFullScreen(true);
    } else {
      setFullScreen(false);
    }
  };

  const handleRightTableFullScreenView = (fullScreenView = false) => {
    setRightTableFullScreen(fullScreenView);
    if (fullScreenView) setLeftTableFullScreen(false);
    if (leftTableFullScreen || fullScreenView) {
      setFullScreen(true);
    } else {
      setFullScreen(false);
    }
  };

  const addSingleRowToDetailsTable = () => {
    if (selectedRow.length === 0) {
      dispatch(dispatchErrorMessages(['Please select from the drug names']));
    } else {
      dispatch(dispatchErrorMessages([]));
      dispatch(checkURAAndAddToDetailsTable(selectedRow));
      gridApi.deselectAll();
    }
  };

  const addAllToDetailsTable = () => {
    if (searchByDrugNameTableData.length == 0) {
      dispatch(dispatchErrorMessages(['NDC not found']));
    } else {
      dispatch(dispatchErrorMessages([]));
      dispatch(checkURAAndAddToDetailsTable(searchByDrugNameTableData));
      gridApi.deselectAll();
    }
  };

  const loadingFunc = (value) => {
    dispatch(setURASearchLoading(value));
  };

  const setClaimError = (message) => {
    dispatch(dispatchErrorMessages([message]));
  };

  const onSearchClick = (searchResult) => {
    if (!searchResult) {
      dispatch(dispatchErrorMessages(['NDC Not Found']));
    } else {
      dispatch(dispatchErrorMessages([]));
    }

    dispatch(setURASearchByDrugNameTableData(searchResult || []));
    loadingFunc(false);
  };

  return (
    <div className="row">
      {!rightTableFullScreen && (
        <>
          <div
            className={`col-${
              leftTableFullScreen ? '12' : '5'
            } d-flex flex-column`}
          >
            {!leftTableFullScreen && !rightTableFullScreen && (
              <SearchComponent
                callback={(result) => onSearchClick(result)}
                loadingFunc={loadingFunc}
                setError={setClaimError}
              />
            )}
            <TableComponent
              setSelectedRow={setSelectedRow}
              searchByDrugNameTableData={searchByDrugNameTableData}
              fullScreen={leftTableFullScreen}
              setFullScreen={handleLeftTableFullScreenView}
              gridApi={gridApi}
              setGridApi={setGridApi}
            />
          </div>
        </>
      )}
      {!leftTableFullScreen && !rightTableFullScreen && (
        <div className="col-2 px-2">
          <MoveToDetailsIconContainer
            handleSingleMove={() => addSingleRowToDetailsTable()}
            handleAllMove={() => addAllToDetailsTable()}
            handleAllRemove={() => {
              dispatch(setURADetailsTableData([]));
            }}
            handleSingleRemove={() => {
              dispatch(removeFromURADetailsTableData());
            }}
          />
        </div>
      )}
      {!leftTableFullScreen && (
        <div
          className={`col-${
            rightTableFullScreen ? '12' : '5'
          } d-flex flex-column`}
          style={{ marginTop: '16px' }}
        >
          <URADetailsTable
            fullScreen={rightTableFullScreen}
            setFullScreen={handleRightTableFullScreenView}
            setError={setError}
            validateForm={validateForm}
            setClickedViewButton={setClickedViewButton}
          />
        </div>
      )}
    </div>
  );
};

export default SearchByDrugName;
